export default __webpack_public_path__ + "static/forme-down-091843fd8aa11edb9a57f482fd2bf823.png";